import React from 'react'
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
  SxProps,
  Theme,
} from '@mui/material'
import {NEUTRAL_SCALE} from 'src/theme-new/tokens'

interface Option {
  value: string
  label: string
}

interface RadioGroupNewProps {
  value: string
  onChange: (value: string) => void
  options: Option[]
  label?: string
  required?: boolean
  disabled?: boolean
  error?: boolean
  helperText?: string
  row?: boolean
  sx?: SxProps<Theme>
}

export default function RadioGroupNew({
  value,
  onChange,
  options,
  label,
  required,
  disabled,
  error,
  helperText,
  row = true,
  sx,
}: RadioGroupNewProps): JSX.Element {
  return (
    <Stack spacing={0.5} sx={sx}>
      {label && (
        <Typography variant="caption" sx={{fontWeight: 600, color: NEUTRAL_SCALE[700], textTransform: 'uppercase', letterSpacing: '0.05em'}}>
          {label}{required && ' *'}
        </Typography>
      )}
      <RadioGroup
        row={row}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map(opt => (
          <FormControlLabel
            key={opt.value}
            value={opt.value}
            disabled={disabled}
            control={<Radio size="small" color="primary" />}
            label={<Typography variant="body2">{opt.label}</Typography>}
          />
        ))}
      </RadioGroup>
      {helperText && (
        <Typography variant="caption" sx={{color: error ? 'error.main' : NEUTRAL_SCALE[500]}}>
          {helperText}
        </Typography>
      )}
    </Stack>
  )
}
